export const EMPTY_VAULE = "EMPTY_VAULE";

export const patientFilterAges = [
  { name: "Всі", value: EMPTY_VAULE },
  { name: "до 24", value: "<24" },
  { name: "25-44", value: "25-44" },
  { name: "45-60", value: "45-60" },
  { name: "Старше 60", value: "60+" },
] as const;

export const patientGenders = [
  { name: "Всі", value: EMPTY_VAULE },
  { name: "Жінка", value: "female" },
  { name: "Чоловік", value: "male" },
  { name: "Інше", value: "unknown" },
] as const;

export const userStatuses = [
  { name: "Всі користувачі", value: EMPTY_VAULE },
  { name: "Зарєєстровані", value: "registered" },
  { name: "Не зареєстровані", value: "notregistered" },
  { name: "Деактивовані", value: "deactivated" },
] as const;

export const patientFilterByLocations = [
  { name: "Всі", value: EMPTY_VAULE },
  {
    name: "Вінницька область",
    value: "vinnytska_oblast",
  },
  {
    name: "Волинська область",
    value: "volynska_oblast",
  },
  {
    name: "Дніпропетровська область",
    value: "dnipropetrovska_oblast",
  },
  {
    name: "Донецька область",
    value: "donetska_oblast",
  },
  {
    name: "Житомирська область",
    value: "zhytomyrska_oblast",
  },
  {
    name: "Закарпатська область",
    value: "zakarpatska_oblast",
  },
  {
    name: "Запорізька область",
    value: "zaporizka_oblast",
  },
  {
    name: "Івано-Франківська область",
    value: "ivano-frankivska_oblast",
  },
  {
    name: "місто Київ",
    value: "misto_kyiv",
  },
  {
    name: "Київська область",
    value: "kyivska_oblast",
  },
  {
    name: "Кіровоградська область",
    value: "kirovohradska_oblast",
  },
  {
    name: "Луганська область",
    value: "luhanska_oblast",
  },
  {
    name: "Львівська область",
    value: "lvivska_oblast",
  },
  {
    name: "Миколаївська область",
    value: "mykolaivska_oblast",
  },
  {
    name: "Одеська область",
    value: "odeska_oblast",
  },
  {
    name: "Полтавська область",
    value: "poltavska_oblast",
  },
  {
    name: "Рівненська область",
    value: "rivnenska_oblast",
  },
  {
    name: "Сумська область",
    value: "sumska_oblast",
  },
  {
    name: "Тернопільська область",
    value: "ternopilska_oblast",
  },
  {
    name: "Харківська область",
    value: "kharkivska_oblast",
  },
  {
    name: "Херсонська область",
    value: "khersonska_oblast",
  },
  {
    name: "Хмельницька область",
    value: "khmelnytska_oblast",
  },
  {
    name: "Черкаська область",
    value: "cherkaska_oblast",
  },
  {
    name: "Чернівецька область",
    value: "chernivetska_oblast",
  },
  {
    name: "Чернігівська область",
    value: "chernihivska_oblast",
  },
  {
    name: "АР Крим",
    value: "ar_krym",
  },
  {
    name: "За кордоном",
    value: "za_kordonom",
  },
] as const;

export const groupByRange = [
  { name: "Тиждень", value: "week" },
  { name: "Місяць", value: "month" },
] as const;

export type FilterElementConfig = {
  name: string;
  title: string;
  options: { name: string; value: string }[];
}[];
